import { Component, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { PartiallyDeliveredReasonsListComponent } from '../../../../components/admin-dashboard-component/partially-delivered-reasons-component/partially-delivered-reasons-list-component/partially-delivered-reasons-list-component';
import { HasScopeDirective } from '../../../../services/scope/has-scope.directive';
import { SCOPES } from '../../../../services/scope/scope-constants';

@Component({
  selector: 'app-partially-delivered-reasons-list',
  standalone: true,
  imports: [
    RouterModule,
    PartiallyDeliveredReasonsListComponent,
    HasScopeDirective,
    
  ],
  templateUrl: './partially-delivered-reasons-list.html',
  styleUrl: './partially-delivered-reasons-list.scss',
})
export class PartiallyDeliveredReasonsList {
  private router = inject(Router);

  readonly SCOPES = SCOPES;
  navigateToAddReason() {
    this.router.navigate([
      '/admin/partially-delivered-reasons/create',
    ]);
  }
}